import Vue from 'vue';
import VueRouter from 'vue-router';
import { ensureUserInitialized } from '@/utils/user';

import Home from "@/views/home/Home.vue";
import Carousel from "@/views/home/children/Carousel.vue";
import Courses from "@/views/home/children/Courses.vue";
import Course from "@/views/courses/Course.vue";
import Description from "@/views/courses/children/Description.vue";
import Lesson from "@/views/courses/children/Lesson.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('@/views/UserAuth.vue'),
  },
  {
    path: '/home',
    component: Home,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'carousel',
        component: Carousel
      },
      {
        path: ':code',
        name: 'courses',
        component: Courses
      }
    ]
  },
  {
    path: '/courses/:code',
    component: Course,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'description',
        component: Description
      },
      {
        path: 'lesson/:lesson',
        name: 'lesson',
        component: Lesson
      }
    ]
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/*',
    redirect: '/home'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (!requiresAuth) return next();

  try {
    await ensureUserInitialized();
    next();
  } catch (e) {
    if (to.path === '/auth') {
      next(); // 已经在 /auth 页面，避免重复跳转
    } else {
      next('/auth');
    }
  }
});

// ✅ 全局封装 router.push 和 replace，避免 NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

export default router;
